import React, { useState } from 'react'
import { PrismicRichText } from '@prismicio/react'
import { Link, StaticQuery, graphql } from 'gatsby'
import { linkResolver } from './../util/linkResolver'

import SocialIconRow from './SocialIconRow'
import { ArrowInCircle, FooterNpfLogo } from './Icons'

import * as Styled from './styles/Footer.styles'

const FOOTER_QUERY = graphql`
  {
    prismicFooter {
      data {
        display_name
        form_prompt_text
        form_prompt_title {
          text
        }
        disclaimer_text {
          richText
        }
        logo_images {
          image {
            alt
            url
            dimensions {
              height
              width
            }
          }
          logo_link {
            url
            target
            link_type
          }
        }
        footer_links {
          link {
            uid
            type
            link_type
            id
            document {
              ... on PrismicSubpage {
                data {
                  title {
                    text
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const NavColumn = ({ links }) => (
  <Styled.NavColumn>
    <Link to="/">
      <FooterNpfLogo />
    </Link>
    <Styled.NavList>
      {links.map(item => (
        <Styled.NavItem key={item.link.id} to={linkResolver(item.link)}>
          <li>{item.link.document.data.title.text}</li>
        </Styled.NavItem>
      ))}
    </Styled.NavList>
    <SocialIconRow marginTop="24px" isFooter={true} />
  </Styled.NavColumn>
)

const CtaButton = ({ action }) => (
  <Styled.SignUpButtonContainer as="button" onClick={action}>
    <Styled.SignUpButtonText>Sign Up</Styled.SignUpButtonText>
    <ArrowInCircle />
  </Styled.SignUpButtonContainer>
)

const FormColumn = ({ node }) => {
  const formNames = {
    FIRST_NAME: 'FNAME',
    LAST_NAME: 'LNAME',
    EMAIL: 'EMAIL',
    ZIP: 'ZIPCODE',
  }

  const [formValues, setFormValues] = useState({
    [formNames.FIRST_NAME]: '',
    [formNames.LAST_NAME]: '',
    [formNames.EMAIL]: '',
    [formNames.ZIP]: '',
  })

  const handleOnChange = e => {
    const { name, value } = e.target

    setFormValues({
      ...formValues,
      [name]: value,
    })
  }

  return (
    <Styled.FormColumn
      action="https://psoriasis.us10.list-manage.com/subscribe/post"
      method="POST"
      noValidate
    >
      <input type="hidden" name="u" value="057ccdf7afdfe6e6c42e356aa" />
      <input type="hidden" name="id" value="02c374486c" />
      <h3>{node.form_prompt_title.text}</h3>
      <h4>{node.form_prompt_text}</h4>
      <Styled.FieldPair>
        <Styled.InputFirstName
          type="text"
          name={formNames.FIRST_NAME}
          placeholder="First Name"
          onChange={handleOnChange}
        />
        <Styled.InputLastName
          type="text"
          name={formNames.LAST_NAME}
          placeholder="Last Name"
          onChange={handleOnChange}
        />
      </Styled.FieldPair>
      <Styled.FieldPair>
        <Styled.InputZip
          name={formNames.ZIP}
          type="text"
          placeholder="Zip"
          onChange={handleOnChange}
        />
        <Styled.InputEmail
          type="email"
          name={formNames.EMAIL}
          placeholder="Email"
          onChange={handleOnChange}
        />
      </Styled.FieldPair>
      <Styled.SubmitRow>
        <CtaButton />
      </Styled.SubmitRow>
      <div
        style={{ position: 'absolute', left: '-5000px' }}
        aria-hidden="true"
        aria-label="Please leave the following three fields empty"
      >
        <label htmlFor="b_name">Name:</label>
        <input
          type="text"
          name="b_name"
          tabIndex="-1"
          defaultValue=""
          placeholder="Freddie"
          id="b_name"
        />
        <label htmlFor="b_email">Email:</label>
        <input
          type="email"
          name="b_email"
          tabIndex="-1"
          defaultValue=""
          placeholder="youremail@gmail.com"
          id="b_email"
        />
        <label htmlFor="b_comment">Comment:</label>
        <textarea
          name="b_comment"
          tabIndex="-1"
          placeholder="Please comment"
          id="b_comment"
        />
      </div>
    </Styled.FormColumn>
  )
}

const Footer = () => (
  <StaticQuery
    query={`${FOOTER_QUERY}`}
    render={data => {
      const node = data.prismicFooter.data
      if (!node) {
        return null
      }

      return (
        <footer style={{ marginTop: '37px' }}>
          <Styled.FooterUpperRegion>
            <Styled.FooterContentRegionGrid>
              <NavColumn links={node.footer_links} />
              <FormColumn node={node} />
            </Styled.FooterContentRegionGrid>
          </Styled.FooterUpperRegion>
          <Styled.FooterLowerRegion>
            <Styled.FooterContentRegionGrid>
              <Styled.LogoRow>
                {node.logo_images.map(logo => (
                  <Styled.LogoLink
                    href={linkResolver(logo.logo_link)}
                    key={logo.image.url}
                    target={logo.logo_link.target}
                  >
                    <Styled.LogoImage
                      src={logo.image.url}
                      alt={logo.image.alt}
                      style={{
                        width: logo.image.dimensions.width,
                        height: logo.image.dimensions.height,
                      }}
                    />
                  </Styled.LogoLink>
                ))}
              </Styled.LogoRow>
              <Styled.Disclaimer>
                <PrismicRichText field={node.disclaimer_text.richText} />
              </Styled.Disclaimer>
            </Styled.FooterContentRegionGrid>
          </Styled.FooterLowerRegion>
        </footer>
      )
    }}
  />
)

export default Footer
